import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instanceldqbxvjihuns as Companion_instance } from './Optional.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CustomScalarTypeClass;
function CustomScalarType() {
  if (CustomScalarTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, className) {
        super(name);
        this.className_1 = className;
      }
    }
    initMetadataForClass($, 'CustomScalarType');
    CustomScalarTypeClass = $;
  }
  return CustomScalarTypeClass;
}
var CompiledNamedTypeClass;
function CompiledNamedType() {
  if (CompiledNamedTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(name) {
        super();
        this.name_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledNamedType');
    CompiledNamedTypeClass = $;
  }
  return CompiledNamedTypeClass;
}
var CompiledTypeClass;
function CompiledType() {
  if (CompiledTypeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledType');
    CompiledTypeClass = $;
  }
  return CompiledTypeClass;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(name, type) {
        this.name_1 = name;
        this.type_1 = type;
        this.alias_1 = null;
        this.condition_1 = emptyList();
        this.arguments_1 = emptyList();
        this.selections_1 = emptyList();
      }
      arguments_2si9qu_k$(arguments_0) {
        // Inline function 'kotlin.apply' call
        this.arguments_1 = arguments_0;
        return this;
      }
      selections_gjxob8_k$(selections) {
        // Inline function 'kotlin.apply' call
        this.selections_1 = selections;
        return this;
      }
      build_1k0s4u_k$() {
        var tmp0_name = this.name_1;
        var tmp1_alias = this.alias_1;
        var tmp2_type = this.type_1;
        var tmp3_condition = this.condition_1;
        var tmp4_arguments = this.arguments_1;
        var tmp5_selections = this.selections_1;
        return new (CompiledField())(tmp0_name, tmp2_type, tmp1_alias, tmp3_condition, tmp4_arguments, tmp5_selections);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompiledFieldClass;
function CompiledField() {
  if (CompiledFieldClass === VOID) {
    class $ extends CompiledSelection() {
      constructor(name, type, alias, condition, arguments_0, selections) {
        super();
        this.name_1 = name;
        this.type_1 = type;
        this.alias_1 = alias;
        this.condition_1 = condition;
        this.arguments_1 = arguments_0;
        this.selections_1 = selections;
      }
    }
    initMetadataForClass($, 'CompiledField');
    CompiledFieldClass = $;
  }
  return CompiledFieldClass;
}
var CompiledSelectionClass;
function CompiledSelection() {
  if (CompiledSelectionClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CompiledSelection');
    CompiledSelectionClass = $;
  }
  return CompiledSelectionClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(definition) {
        this.definition_1 = definition;
        this.value_1 = Companion_instance.absent_njrah3_k$();
      }
      value_oig1rm_k$(value) {
        // Inline function 'kotlin.apply' call
        this.value_1 = Companion_instance.present_fg06t6_k$(value);
        return this;
      }
      build_1k0s4u_k$() {
        return new (CompiledArgument())(this.definition_1, this.value_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var CompiledArgumentClass;
function CompiledArgument() {
  if (CompiledArgumentClass === VOID) {
    class $ {
      constructor(definition, value) {
        this.definition_1 = definition;
        this.value_1 = value;
      }
    }
    initMetadataForClass($, 'CompiledArgument');
    CompiledArgumentClass = $;
  }
  return CompiledArgumentClass;
}
var BuilderClass_1;
function Builder_1() {
  if (BuilderClass_1 === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
        this.isKey_1 = false;
      }
      build_1k0s4u_k$() {
        return new (CompiledArgumentDefinition())(this.name_1, this.isKey_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_1 = $;
  }
  return BuilderClass_1;
}
var CompiledArgumentDefinitionClass;
function CompiledArgumentDefinition() {
  if (CompiledArgumentDefinitionClass === VOID) {
    class $ {
      constructor(name, isKey) {
        this.name_1 = name;
        this.isKey_1 = isKey;
        this.isPagination_1 = false;
      }
    }
    initMetadataForClass($, 'CompiledArgumentDefinition');
    CompiledArgumentDefinitionClass = $;
  }
  return CompiledArgumentDefinitionClass;
}
var CompiledVariableClass;
function CompiledVariable() {
  if (CompiledVariableClass === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
      }
    }
    initMetadataForClass($, 'CompiledVariable');
    CompiledVariableClass = $;
  }
  return CompiledVariableClass;
}
var BuilderClass_2;
function Builder_2() {
  if (BuilderClass_2 === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
        this.keyFields_1 = emptyList();
        this.implements_1 = emptyList();
      }
      build_1k0s4u_k$() {
        return new (ObjectType())(this.name_1, this.keyFields_1, this.implements_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_2 = $;
  }
  return BuilderClass_2;
}
var ObjectTypeClass;
function ObjectType() {
  if (ObjectTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, keyFields, implements_0) {
        super(name);
        this.keyFields_1 = keyFields;
        this.implements_1 = implements_0;
        this.embeddedFields_1 = emptyList();
      }
    }
    initMetadataForClass($, 'ObjectType');
    ObjectTypeClass = $;
  }
  return ObjectTypeClass;
}
var CompiledNotNullTypeClass;
function CompiledNotNullType() {
  if (CompiledNotNullTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(ofType) {
        super();
        this.ofType_1 = ofType;
      }
    }
    initMetadataForClass($, 'CompiledNotNullType');
    CompiledNotNullTypeClass = $;
  }
  return CompiledNotNullTypeClass;
}
function notNull(_this__u8e3s4) {
  return new (CompiledNotNullType())(_this__u8e3s4);
}
var CompiledListTypeClass;
function CompiledListType() {
  if (CompiledListTypeClass === VOID) {
    class $ extends CompiledType() {
      constructor(ofType) {
        super();
        this.ofType_1 = ofType;
      }
    }
    initMetadataForClass($, 'CompiledListType');
    CompiledListTypeClass = $;
  }
  return CompiledListTypeClass;
}
function list(_this__u8e3s4) {
  return new (CompiledListType())(_this__u8e3s4);
}
var BuilderClass_3;
function Builder_3() {
  if (BuilderClass_3 === VOID) {
    class $ {
      constructor(typeCondition, possibleTypesSet) {
        this.typeCondition_1 = typeCondition;
        this.possibleTypesSet_1 = possibleTypesSet;
        this.condition_1 = emptyList();
        this.selections_1 = emptyList();
      }
      selections_gjxob8_k$(selections) {
        // Inline function 'kotlin.apply' call
        this.selections_1 = selections;
        return this;
      }
      build_1k0s4u_k$() {
        return new (CompiledFragment())(this.typeCondition_1, this.possibleTypesSet_1, this.condition_1, this.selections_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_3 = $;
  }
  return BuilderClass_3;
}
var CompiledFragmentClass;
function CompiledFragment() {
  if (CompiledFragmentClass === VOID) {
    class $ extends CompiledSelection() {
      constructor(typeCondition, possibleTypesSet, condition, selections) {
        super();
        this.typeCondition_1 = typeCondition;
        this.possibleTypesSet_1 = possibleTypesSet;
        this.condition_1 = condition;
        this.selections_1 = selections;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.possibleTypes$delegate_1 = lazy(tmp_0, () => toList(this.possibleTypesSet_1));
      }
    }
    initMetadataForClass($, 'CompiledFragment');
    CompiledFragmentClass = $;
  }
  return CompiledFragmentClass;
}
var EnumTypeClass;
function EnumType() {
  if (EnumTypeClass === VOID) {
    class $ extends CompiledNamedType() {
      constructor(name, values) {
        super(name);
        this.values_1 = values;
      }
    }
    initMetadataForClass($, 'EnumType');
    EnumTypeClass = $;
  }
  return EnumTypeClass;
}
//region block: exports
export {
  Builder_0 as Builder3t31vflw4km89,
  Builder_1 as Builderlyags3ldja2y,
  Builder as Builder320ghmibyd2no,
  Builder_3 as Builder2iaenv1j4gk4w,
  CompiledVariable as CompiledVariablecaz6ndkw7us2,
  CustomScalarType as CustomScalarType8w7iuefxipic,
  EnumType as EnumType11cgb4df0n5r9,
  Builder_2 as Builder3vv3qt9kyowg0,
  list as lista11lrkbcitk,
  notNull as notNull3hndh47e9bowl,
};
//endregion

//# sourceMappingURL=CompiledGraphQL.mjs.map
